import graphql from 'babel-plugin-relay/macro';
import { commitMutation } from 'react-relay';
import AbEnvironment from '../auth/AbEnvironment';
  
  const abEnvironment = new AbEnvironment();
  const mutation = graphql`
  mutation CustomerServiceUpdateMutation($input: UpdateCustomerServiceTByCustomerServiceIdInput!) {
    updateCustomerServiceTByCustomerServiceId(input: $input) {
      customerServiceT {
        customerServiceId
        appId
        customerAccountId
        parentAppId
        serviceStatus
        atId
        appSkuPrice
        notes
        billingFrequency
        billingDayOfMonth
        paymentOrder
        passThroughFees
        created
        createdBy
        updated
        updatedBy
      }
    }
  }
  `;

  function commit(customerServiceId, serviceStatus,
                  atId, appSkuPrice, notes,
                  paymentOrder, billingFrequency,
                  passThroughFees, billingDayOfMonth) 
  {
    var variables = {
        input: {
          customerServiceId,
          customerServiceTPatch: {}
        }
      }
      
    if (serviceStatus != null)
      variables.input.customerServiceTPatch.serviceStatus = serviceStatus;
    if (atId != null)
      variables.input.customerServiceTPatch.atId = atId;
    if (appSkuPrice != null)
      variables.input.customerServiceTPatch.appSkuPrice = appSkuPrice;
    if (notes != null)
      variables.input.customerServiceTPatch.notes = notes;
    if (paymentOrder != null)
      variables.input.customerServiceTPatch.paymentOrder = paymentOrder;
    if (passThroughFees != null)
      variables.input.customerServiceTPatch.passThroughFees = passThroughFees;
    if (billingFrequency != null)
      variables.input.customerServiceTPatch.billingFrequency = billingFrequency;
    if (billingDayOfMonth === 0)
      variables.input.customerServiceTPatch.billingDayOfMonth = null;
    if (billingDayOfMonth !== 0)
      variables.input.customerServiceTPatch.billingDayOfMonth = billingDayOfMonth;

    return new Promise((resolve, reject) => {

      //If nothing changed, do not attempt to commit.
      //https://stackoverflow.com/questions/679915/how-do-i-test-for-an-empty-javascript-object
      if (JSON.stringify(variables.input.customerServiceTPatch) === JSON.stringify({})) {
        resolve({});
      } else {
        commitMutation(
          abEnvironment.getEnvironment(), {
            mutation,
            variables,
            updater: (store) => {
              // Mutation store - values that have been updated / returned
              const payload = store.getRootField('updateCustomerServiceTByCustomerServiceId');
              const theCustomerApp = payload.getLinkedRecord('customerServiceT');
  
              // Retrieved store - assumes that all callers are components that have queried
              // subscription by 'customerAppTByCustomerAppId'.
              let preSaveCustomerService = null;
              const theRoot = store.getRoot();

              const preSaveCustomerServiceId = 'customerServiceTByCustomerServiceId(customerAppId:"' + customerServiceId + '")';
              preSaveCustomerService = theRoot.getLinkedRecord(preSaveCustomerServiceId);
  
              if (preSaveCustomerService != null) 
              {
                // Could restrict to just what has changed, but just do all returned values,
                // which is correct.
                preSaveCustomerService.setValue(theCustomerApp.getValue('serviceStatus'),        'serviceStatus');
                preSaveCustomerService.setValue(theCustomerApp.getValue('appSkuPrice'),         'appSkuPrice');
                preSaveCustomerService.setValue(theCustomerApp.getValue('billingFrequency'),    'billingFrequency');
                preSaveCustomerService.setValue(theCustomerApp.getValue('notes'),               'notes');
                preSaveCustomerService.setValue(theCustomerApp.getValue('paymentOrder'),        'paymentOrder');
                preSaveCustomerService.setValue(theCustomerApp.getValue('passThroughFees'),     'passThroughFees');
              }
            },
            onCompleted: (response) => {
              resolve(response);
            },
            onError: (error) => {
              reject(error);
            }
        });  
      }


    });
  }
  /* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
  export default { commit };
  